import axios from 'axios';

const csrfToken = document.querySelector("[name=csrf-token]").content;

const lmsAPI = axios.create({
  baseURL: "/api/",
  headers: {
    "X-CSRF-TOKEN": csrfToken,
  },
});

lmsAPI.interceptors.response.use((response) => {
  if (response.data?.redirect_to_url) {
    window.location.href = response.data.redirect_to_url;
  }
  return response;
});

lmsAPI.interceptors.request.use(async (request) => {
  // App Bridge v4: Get session token for embedded app authentication
  if (window.shopify?.idToken) {
    try {
      const token = await Promise.race([
        window.shopify.idToken(),
        new Promise((_, reject) => setTimeout(() => reject(new Error('Token timeout')), 3000))
      ]);
      
      if (token) {
        request.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (error) {
      console.error("[lmsAPI] Failed to get session token:", error.message);
    }
  } else {
    console.error("[lmsAPI] App Bridge not initialized - session token unavailable");
  }
  
  return request;
});

export default lmsAPI;
